import React, { useEffect, useMemo } from 'react';
import { Alert, Button, Col, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';

import store from '../store';
import {
    selectStorageSize,
    selectStorageType,
    setStorageSize,
    setStorageType,
} from '../store/bookingSlice';

import {
    selectAllLocations,
    useGetLocationsQuery,
} from '../features/rapidstor/rapidstorApiSlice';

import classes from './LocationCard.module.scss';

import LocationCard from './LocationCard';
import Map from './Map';
import Navbar from './Navbar';
import Spinner from './Spinner';

function LocationSelector() {
    const { isLoading, error, refetch } = useGetLocationsQuery();
    const locations = useSelector(selectAllLocations);
    const storageType = useSelector(selectStorageType);
    const storageSize = useSelector(selectStorageSize);

    // If the user navigates back to the location selector, reset the storage type and size
    useEffect(() => {
        if (storageType !== null || storageSize !== null) {
            store.dispatch(setStorageSize(null));
            store.dispatch(setStorageType(null));
        }
    }, [storageSize, storageType]);

    const displayLocations = useMemo(() => {
        const ashford = structuredClone(
            locations.find((location) => location.locationCode === 'ASH')
        );
        if (!ashford) {
            return locations;
        }

        ashford.name = 'Ashford';

        return [...locations, ashford].sort((a, b) => a.name.localeCompare(b.name));
    }, [locations]);

    const content = useMemo(() => {
        if (isLoading && displayLocations.length === 0) {
            return <Spinner center size={100} />;
        } else if (error) {
            return (
                <Col>
                    <Alert>
                        Sorry, we were unable to load the list of facilities.
                        <div className={'mt-2'}>
                            <Button onClick={refetch}>Retry</Button>
                        </div>
                    </Alert>
                </Col>
            );
        } else {
            return displayLocations.map((location) => (
                <Col
                    xs={6}
                    sm={6}
                    lg={3}
                    key={location.name}
                    style={{ padding: '0 8px' }}
                >
                    <LocationCard location={location} ash={location.name === 'Ashford'} />
                </Col>
            ));
        }
    }, [isLoading, displayLocations, error, refetch]);
    return (
        <>
            {/* Header */}
            <Navbar label='Select location' />

            {/* Location List */}
            <Row style={{ maxWidth: '980px', margin: '0 auto', padding: '0 8px' }}>
                {content}
            </Row>

            {/* Map */}
            {locations.length > 0 && (
                <div className={`${classes.map_container}`}>
                    <div className={`${classes.header}`}>
                        <span>Our locations</span>
                        <span>
                            We have {locations.length} great facilities in Adelaide
                        </span>
                    </div>
                    <Map />
                </div>
            )}
        </>
    );
}

export default LocationSelector;
